import React from 'react';
import UtilityService from '../../../services/UtilityService';

export const OuterLabelTestId = 'outerlabel-input';

type OuterLabelProps = {
  children: string;
  inputName: string;
  hasErrors: boolean;
  className?: string;
  renderChild?: boolean;
};

const OuterLabel: React.FC<OuterLabelProps> = ({
  children,
  inputName,
  hasErrors,
  className = '',
  renderChild = false,
}: OuterLabelProps) => {
  const classes = `${className} text-sm ${hasErrors ? 'input-error-text' : ''}`;

  return renderChild ? (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label
      htmlFor={inputName}
      className={classes}
      data-testid={OuterLabelTestId}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: UtilityService.sanitizeHtml(children),
      }}
    />
  ) : (
    <label
      htmlFor={inputName}
      className={classes}
      data-testid={OuterLabelTestId}
    >
      {children}
    </label>
  );
};

export default OuterLabel;
